const SHADES_RATIOS = { shade1: 0.1, shade2: 0.3, shade3: 0.5 };
const HEX_COLOR_RE = /^#?([0-9a-fA-F]{6})$/;
const parseHexToRgb = (hex) => {
  const match = hex.match(HEX_COLOR_RE);
  if (!match) {
    return { r: 0, g: 0, b: 0 };
  }
  const h = match[1];
  return {
    r: parseInt(h.substring(0, 2), 16),
    g: parseInt(h.substring(2, 4), 16),
    b: parseInt(h.substring(4, 6), 16)
  };
};
const rgbToHexString = ({ r, g, b }) => {
  const toHex = (v) => Math.round(v).toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
const clampChannel = (v) => Math.round(Math.min(255, Math.max(0, v)));
const mixChannels = (dark, light, darkRatio) => ({
  r: clampChannel(darkRatio * dark.r + (1 - darkRatio) * light.r),
  g: clampChannel(darkRatio * dark.g + (1 - darkRatio) * light.g),
  b: clampChannel(darkRatio * dark.b + (1 - darkRatio) * light.b)
});
const calculateShades = (lightHex, darkHex) => {
  const light = parseHexToRgb(lightHex);
  const dark = parseHexToRgb(darkHex);
  return [
    rgbToHexString(mixChannels(dark, light, SHADES_RATIOS.shade1)),
    rgbToHexString(mixChannels(dark, light, SHADES_RATIOS.shade2)),
    rgbToHexString(mixChannels(dark, light, SHADES_RATIOS.shade3))
  ];
};
const hexToRgba = (alphaHex, opacity) => {
  if (!alphaHex) {
    return "";
  }
  const opacityPercentage = opacity ?? getOpacityFromHex(alphaHex);
  let hexColor = getHexColorFromAlpha(alphaHex)?.replace(/^#/, "") ?? "";
  if (hexColor.length === 3) {
    hexColor = hexColor.split("").map((char) => char + char).join("");
  }
  const bigint = parseInt(hexColor, 16);
  const r = bigint >> 16 & 255;
  const g = bigint >> 8 & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}${opacityPercentage !== void 0 ? `, ${opacityPercentage / 100}` : ""})`;
};
const combineHexWithOpacity = (hexColor, opacityPercentage) => {
  if (!hexColor) {
    return;
  }
  const alpha = Math.round(opacityPercentage / 100 * 255);
  const alphaHex = alpha.toString(16).padStart(2, "0").toUpperCase();
  return `${hexColor?.slice(0, 7)}${alphaHex}`;
};
const getOpacityFromHex = (hexColorWithAlpha) => {
  if (!hexColorWithAlpha || hexColorWithAlpha.length === 7) {
    return 100;
  }
  const hex = hexColorWithAlpha.replace("#", "");
  const alphaHex = hex.slice(6, 8);
  const alphaDecimal = parseInt(alphaHex, 16);
  return Math.round(alphaDecimal / 255 * 100);
};
const getHexColorFromAlpha = (hexColorWithAlpha) => {
  if (!hexColorWithAlpha || hexColorWithAlpha.length === 7) {
    return hexColorWithAlpha;
  }
  return hexColorWithAlpha.slice(0, 7);
};
export {
  calculateShades,
  combineHexWithOpacity,
  getHexColorFromAlpha,
  getOpacityFromHex,
  hexToRgba
};
//# sourceMappingURL=color-utils.js.map
